import classNames from 'classnames';

const GlutenSmartIcon = ({ className = '', hcSelected = false, tempoSelected = false }) => {
  if (hcSelected) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Gluten-Smart</title>
        <g clipPath="url(#clip0_653_2448)">
          <path d="M14.3498 7.59998L9.5498 10.6V24.4L14.3498 20.8V7.59998Z" fill="#99CE99" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.05218 4.65109V6.50846L9.40341 9.02175V4.65109C9.40341 4.47841 9.472 4.3128 9.5941 4.1907C9.71621 4.06859 9.88182 4 10.0545 4C10.2272 4 10.3928 4.06859 10.5149 4.1907C10.637 4.3128 10.7056 4.47841 10.7056 4.65109V9.02831L14.0589 6.51386V4.65109C14.0589 4.47841 14.1275 4.3128 14.2496 4.1907C14.3717 4.06859 14.5373 4 14.71 4C14.8827 4 15.0483 4.06859 15.1704 4.1907C15.2925 4.3128 15.3611 4.47841 15.3611 4.65109V5.53744L15.3648 5.5347V19.9264C15.3643 20.2979 15.2778 20.6643 15.1122 20.9968C14.9465 21.3293 14.7061 21.619 14.4098 21.8432L10.7056 24.6169V27.3489C10.7056 27.5216 10.637 27.6872 10.5149 27.8093C10.3928 27.9314 10.2272 28 10.0545 28C9.88182 28 9.71621 27.9314 9.5941 27.8093C9.472 27.6872 9.40341 27.5216 9.40341 27.3489V24.6148L5.70869 21.8432C5.4123 21.6191 5.17183 21.3294 5.00615 20.9969C4.84047 20.6643 4.75409 20.2979 4.75375 19.9264V19.7055C4.75126 19.6824 4.75 19.6591 4.75 19.6357V4.65109C4.75 4.47841 4.81859 4.3128 4.9407 4.1907C5.0628 4.06859 5.22841 4 5.40109 4C5.57377 4 5.73938 4.06859 5.86148 4.1907C5.98358 4.3128 6.05218 4.47841 6.05218 4.65109ZM14.0589 17.4473V19.6357C14.0589 19.6409 14.059 19.646 14.0591 19.6512V19.9264C14.0585 20.0963 14.0186 20.2637 13.9425 20.4157C13.8665 20.5676 13.7563 20.6999 13.6207 20.8023L10.7056 22.9884V19.9622L14.0589 17.4473ZM14.0589 12.7927V15.8196L10.7056 18.3345V15.3082L14.0589 12.7927ZM14.0589 8.13919V11.1649L10.7056 13.6797V10.6535L14.0589 8.13919ZM6.05246 12.7935V15.8204L9.40341 18.3334V15.3071L6.05246 12.7935ZM6.05246 19.9264V17.4481L9.40341 19.9611V22.9869L6.49086 20.8014C6.35491 20.6996 6.24451 20.5675 6.16842 20.4156C6.09233 20.2637 6.05263 20.0962 6.05246 19.9264ZM9.40341 13.6786V10.6521L6.05246 8.13905V11.1656L9.40341 13.6786Z"
            className="fill-green-130"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.2065 4.76868C22.2065 4.40624 21.9127 4.11243 21.5503 4.11243C21.1878 4.11243 20.894 4.40624 20.894 4.76868V25.8416L17.209 22.2429C16.9497 21.9897 16.5342 21.9946 16.281 22.2539C16.0278 22.5132 16.0327 22.9287 16.292 23.1819L20.961 27.7415C21.2888 28.0616 21.8122 28.0616 22.14 27.7415L26.809 23.1819C27.0683 22.9287 27.0732 22.5132 26.82 22.2539C26.5668 21.9946 26.1513 21.9897 25.892 22.2429L22.2065 25.842V4.76868Z"
            className="fill-green-130"
          />
        </g>
        <defs>
          <clipPath id="clip0_653_2448">
            <rect width="24" height="24" fill="#99CE99" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
    );
  } else if (tempoSelected) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Gluten-Smart</title>
        <g clipPath="url(#clip0_653_2448)">
          <path
            d="M14.3498 7.59998L9.5498 10.6V24.4L14.3498 20.8V7.59998Z"
            className="fill-tempo-blue-70"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.05218 4.65109V6.50846L9.40341 9.02175V4.65109C9.40341 4.47841 9.472 4.3128 9.5941 4.1907C9.71621 4.06859 9.88182 4 10.0545 4C10.2272 4 10.3928 4.06859 10.5149 4.1907C10.637 4.3128 10.7056 4.47841 10.7056 4.65109V9.02831L14.0589 6.51386V4.65109C14.0589 4.47841 14.1275 4.3128 14.2496 4.1907C14.3717 4.06859 14.5373 4 14.71 4C14.8827 4 15.0483 4.06859 15.1704 4.1907C15.2925 4.3128 15.3611 4.47841 15.3611 4.65109V5.53744L15.3648 5.5347V19.9264C15.3643 20.2979 15.2778 20.6643 15.1122 20.9968C14.9465 21.3293 14.7061 21.619 14.4098 21.8432L10.7056 24.6169V27.3489C10.7056 27.5216 10.637 27.6872 10.5149 27.8093C10.3928 27.9314 10.2272 28 10.0545 28C9.88182 28 9.71621 27.9314 9.5941 27.8093C9.472 27.6872 9.40341 27.5216 9.40341 27.3489V24.6148L5.70869 21.8432C5.4123 21.6191 5.17183 21.3294 5.00615 20.9969C4.84047 20.6643 4.75409 20.2979 4.75375 19.9264V19.7055C4.75126 19.6824 4.75 19.6591 4.75 19.6357V4.65109C4.75 4.47841 4.81859 4.3128 4.9407 4.1907C5.0628 4.06859 5.22841 4 5.40109 4C5.57377 4 5.73938 4.06859 5.86148 4.1907C5.98358 4.3128 6.05218 4.47841 6.05218 4.65109ZM14.0589 17.4473V19.6357C14.0589 19.6409 14.059 19.646 14.0591 19.6512V19.9264C14.0585 20.0963 14.0186 20.2637 13.9425 20.4157C13.8665 20.5676 13.7563 20.6999 13.6207 20.8023L10.7056 22.9884V19.9622L14.0589 17.4473ZM14.0589 12.7927V15.8196L10.7056 18.3345V15.3082L14.0589 12.7927ZM14.0589 8.13919V11.1649L10.7056 13.6797V10.6535L14.0589 8.13919ZM6.05246 12.7935V15.8204L9.40341 18.3334V15.3071L6.05246 12.7935ZM6.05246 19.9264V17.4481L9.40341 19.9611V22.9869L6.49086 20.8014C6.35491 20.6996 6.24451 20.5675 6.16842 20.4156C6.09233 20.2637 6.05263 20.0962 6.05246 19.9264ZM9.40341 13.6786V10.6521L6.05246 8.13905V11.1656L9.40341 13.6786Z"
            className="fill-tempo-blue-120"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.2065 4.76868C22.2065 4.40624 21.9127 4.11243 21.5503 4.11243C21.1878 4.11243 20.894 4.40624 20.894 4.76868V25.8416L17.209 22.2429C16.9497 21.9897 16.5342 21.9946 16.281 22.2539C16.0278 22.5132 16.0327 22.9287 16.292 23.1819L20.961 27.7415C21.2888 28.0616 21.8122 28.0616 22.14 27.7415L26.809 23.1819C27.0683 22.9287 27.0732 22.5132 26.82 22.2539C26.5668 21.9946 26.1513 21.9897 25.892 22.2429L22.2065 25.842V4.76868Z"
            className="fill-tempo-blue-120"
          />
        </g>
        <defs>
          <clipPath id="clip0_653_2448">
            <rect
              width="24"
              height="24"
              className="fill-tempo-blue-70"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Gluten-Smart</title>
        <g clipPath="url(#clip0_653_2448)">
          <path d="M14.3498 7.59998L9.5498 10.6V24.4L14.3498 20.8V7.59998Z" fill="transparent" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.05218 4.65109V6.50846L9.40341 9.02175V4.65109C9.40341 4.47841 9.472 4.3128 9.5941 4.1907C9.71621 4.06859 9.88182 4 10.0545 4C10.2272 4 10.3928 4.06859 10.5149 4.1907C10.637 4.3128 10.7056 4.47841 10.7056 4.65109V9.02831L14.0589 6.51386V4.65109C14.0589 4.47841 14.1275 4.3128 14.2496 4.1907C14.3717 4.06859 14.5373 4 14.71 4C14.8827 4 15.0483 4.06859 15.1704 4.1907C15.2925 4.3128 15.3611 4.47841 15.3611 4.65109V5.53744L15.3648 5.5347V19.9264C15.3643 20.2979 15.2778 20.6643 15.1122 20.9968C14.9465 21.3293 14.7061 21.619 14.4098 21.8432L10.7056 24.6169V27.3489C10.7056 27.5216 10.637 27.6872 10.5149 27.8093C10.3928 27.9314 10.2272 28 10.0545 28C9.88182 28 9.71621 27.9314 9.5941 27.8093C9.472 27.6872 9.40341 27.5216 9.40341 27.3489V24.6148L5.70869 21.8432C5.4123 21.6191 5.17183 21.3294 5.00615 20.9969C4.84047 20.6643 4.75409 20.2979 4.75375 19.9264V19.7055C4.75126 19.6824 4.75 19.6591 4.75 19.6357V4.65109C4.75 4.47841 4.81859 4.3128 4.9407 4.1907C5.0628 4.06859 5.22841 4 5.40109 4C5.57377 4 5.73938 4.06859 5.86148 4.1907C5.98358 4.3128 6.05218 4.47841 6.05218 4.65109ZM14.0589 17.4473V19.6357C14.0589 19.6409 14.059 19.646 14.0591 19.6512V19.9264C14.0585 20.0963 14.0186 20.2637 13.9425 20.4157C13.8665 20.5676 13.7563 20.6999 13.6207 20.8023L10.7056 22.9884V19.9622L14.0589 17.4473ZM14.0589 12.7927V15.8196L10.7056 18.3345V15.3082L14.0589 12.7927ZM14.0589 8.13919V11.1649L10.7056 13.6797V10.6535L14.0589 8.13919ZM6.05246 12.7935V15.8204L9.40341 18.3334V15.3071L6.05246 12.7935ZM6.05246 19.9264V17.4481L9.40341 19.9611V22.9869L6.49086 20.8014C6.35491 20.6996 6.24451 20.5675 6.16842 20.4156C6.09233 20.2637 6.05263 20.0962 6.05246 19.9264ZM9.40341 13.6786V10.6521L6.05246 8.13905V11.1656L9.40341 13.6786Z"
            fill="#4A4A4A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.2065 4.76868C22.2065 4.40624 21.9127 4.11243 21.5503 4.11243C21.1878 4.11243 20.894 4.40624 20.894 4.76868V25.8416L17.209 22.2429C16.9497 21.9897 16.5342 21.9946 16.281 22.2539C16.0278 22.5132 16.0327 22.9287 16.292 23.1819L20.961 27.7415C21.2888 28.0616 21.8122 28.0616 22.14 27.7415L26.809 23.1819C27.0683 22.9287 27.0732 22.5132 26.82 22.2539C26.5668 21.9946 26.1513 21.9897 25.892 22.2429L22.2065 25.842V4.76868Z"
            fill="#4A4A4A"
          />
        </g>
        <defs>
          <clipPath id="clip0_653_2448">
            <rect width="24" height="24" fill="transparent" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
    );
  }
};

GlutenSmartIcon.propTypes = {
  className: PropTypes.string,
  hcSelected: PropTypes.bool,
  tempoSelected: PropTypes.bool,
};

export default GlutenSmartIcon;
